import { Box, Stack, Typography, useTheme } from "@mui/material";

type DatagridEmptyState = {
  Icon: MuiIconType;
  text: string;
};

const DatagridEmptyState = ({ Icon, text }: DatagridEmptyState) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "120px",
        backgroundColor: theme.palette.surfaceLight10.main,
      }}
    >
      <Stack direction="row" sx={{ gap: "8px", alignItems: "center", justifyContent: "center" }}>
        <Icon size={24} color={theme.palette.text40.main} />
        <Typography variant="body.large.regular" sx={{ color: "text40.main" }}>
          {text}
        </Typography>
      </Stack>
    </Box>
  );
};

export { DatagridEmptyState };
